var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSignoutLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 18.0627C14.9137 20.2234 13.1135 22.0574 10.702 21.999C10.1408 21.985 9.44667 21.789 8.0595 21.3982C4.72167 20.4567 1.82367 18.8735 1.12833 15.328C1 14.6782 1 13.9444 1 12.4767V10.5237C1 9.05719 1 8.32335 1.12833 7.67119C1.82367 4.12685 4.72167 2.54369 8.0595 1.60219C9.44783 1.21135 10.1408 1.01535 10.702 1.00135C13.1135 0.943021 14.9137 2.77702 15 4.93769M22 11.5002H9.16667M22 11.5002C22 10.6835 19.6737 9.15752 19.0833 8.58352M22 11.5002C22 12.3169 19.6737 13.8429 19.0833 14.4169",
    stroke: "#242424",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignoutLight);
export default __webpack_public_path__ + "static/media/signout-light.4e2c79dccfb30a25963dc653d4d48f2a.svg";
export { ForwardRef as ReactComponent };